import React from 'react';
import { Tag } from 'lucide-react';

const AttributionBlock = ({ record }) => {
  const fields = [
    ['Source', record.utm_source],
    ['Medium', record.utm_medium],
    ['Campaign', record.utm_campaign],
    ['Content', record.utm_content],
    ['Term', record.utm_term],
    ['Landing Page', record.landing_page],
    ['First Page', record.first_page_visited],
  ];
  const populated = fields.filter(([, v]) => v);
  if (populated.length === 0) {
    return (
      <div className="attribution-block attribution-empty" data-testid="attribution-empty">
        <Tag size={12} /> Direct / No UTM captured
      </div>
    );
  }
  return (
    <div className="attribution-block" data-testid="attribution-block">
      <div className="attribution-header"><Tag size={12} /> Attribution</div>
      <div className="attribution-grid">
        {populated.map(([label, val]) => (
          <div key={label} className="attribution-row">
            <span className="attribution-label">{label}</span>
            <code className="attribution-value">{val}</code>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttributionBlock;
